import { Atom, useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { useUpdateQueryString } from '@/hooks/useUpdateQueryString';

import { LinkConfig } from '@/types/navigation';

const useGetLinkPath = (linkConfigAtom: Atom<LinkConfig>, ids: Record<string, string | number> = {}) => {
  const {
    i18n: { language },
  } = useTranslation();
  const { path, relative, params, removeOtherParams } = useAtomValue(linkConfigAtom);
  const [searchParams] = useSearchParams();
  const updateQueryString = useUpdateQueryString(removeOtherParams ? new URLSearchParams() : searchParams);

  const search = updateQueryString(
    params.map(param => {
      if (!ids[param]) throw new Error(`Missing param '${param}' in link ids`);
      return { key: param, value: `${ids[param]}` };
    }),
    [],
  );

  let to = path.replace(':language', language);

  Object.keys(ids).forEach(key => {
    to = `${to.replace(`:${key}`, `${ids[key]}`)}`;
  });

  if (search) {
    to = `${to}?${search}`;
  }

  return { to, relative };
};

export default useGetLinkPath;
